// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._1cy7KDJ8CFCZjNazyHSX-n {\r\n    min-height: var(--vertical-rythm);\r\n    background: black;\r\n\r\n    background-color : var(--utility-black);\r\n    \r\n    color: var(--utility-white);\r\n    \r\n    display: flex;\r\n    align-items: center;\r\n    position: relative;\r\n    \r\n    padding: 0 12px;\r\n}\r\n\r\n\r\n._3IJHFn9jF_OeoL8IAAXGZW { background-color: var(--utility-yellow); }\r\n._2D6WqPD_iuKXbhfUT8XmaV { background-color: var(--utility-red); }\r\n.vV7fVbmrlHbsggZBC1JlD { background-color: var(--utility-green); }\r\n", ""]);
// Exports
exports.locals = {
	"container": "_1cy7KDJ8CFCZjNazyHSX-n",
	"warning": "_3IJHFn9jF_OeoL8IAAXGZW",
	"error": "_2D6WqPD_iuKXbhfUT8XmaV",
	"success": "vV7fVbmrlHbsggZBC1JlD"
};
module.exports = exports;
